import { useNavigate } from "react-router-dom"
import { useEffect, useCallback, useRef } from "react";
import { useDispatch } from 'react-redux';
import { completeAuthentication, setCurrentUser, setTokens, startPeriodicRefresh } from "../../redux";

export default function Home() {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const hasCalledAuthentication = useRef(false);
  
    const authenticateUser = useCallback(async (code) => {   
        if (code) {
            try {                
                const data = await dispatch(completeAuthentication(code)).unwrap();
                if (data) {
                    const userDetails = JSON.parse(atob(data.access_token.split('.')[1]));                             
                    const aud = userDetails.aud;                   
                    await dispatch(setCurrentUser({ userDetails, aud }));
                    dispatch(setTokens(data));
                    
                    // Start periodic token refresh
                    dispatch(startPeriodicRefresh());
                    
                    navigate('/home'); 
                }
            } catch (error) {
                console.error('❌ Authentication failed:', error);
                hasCalledAuthentication.current = false; // Reset on error so it can retry
            }
        } else {
            navigate('/login');
        }
    }, [navigate, dispatch]);

    useEffect(() => {
        // Prevent duplicate calls from React.StrictMode in development
        if (hasCalledAuthentication.current) {
            return;
        }
        
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');
        
        if (code) {
            hasCalledAuthentication.current = true;
            authenticateUser(code);
        } else {
            navigate('/login');
        }
    }, [authenticateUser, navigate]);
  return (   
    <>
    </>
  );
}
